$(document).ready(function(){
	
	var $question = $('.quiz-question');

	var bounce = function($element,initialDistance, times, damping) {
		for(var i=1; i<=times; i++){
			var an = Math.pow(-1,i)*initialDistance/(i*damping);
			$element.animate({'top':an},80);
		}
		$element.animate({'top':0},80);
	}
	
	$question.on('click', 'a.quiz-choice', function(e){
		e.preventDefault();
		
		var $a = $(this),
			url = $a.attr('href'),
			choice = url.substring(url.lastIndexOf('/') + 1),
			$next = $('a.next'),
			redirect;
		
		// Reset any previously selected choice
		$('div.followup').hide();
		$('a.quiz-choice').removeClass('selected');
		
		// Select this choice
		$('#followup_' + choice).fadeIn('fast');
		$a.addClass('selected');
		
		// Handle any redirects
		if ($a.data('redirect')) {
			redirect = $a.data('redirect');
		}
		else if ($next.hasClass('redirect')) {
			redirect = $next.attr('href');
		}
		
		if (redirect) {
			if ($question.hasClass('last')) {
				$question.replaceWith('<div class="quiz-calculating"><h1>'+$question.data('msg-calculating')+'</h1></div>');
				setTimeout(function(){ window.location.href = redirect; }, 1000);
			} else {
				window.location.href = redirect;
			}
		}

		
		// Show next button
		$next.animate({
			opacity: 1
		}, 50);
		
		bounce($next, -25, 6, 1.5);
		
		// Setup swipe to next question
		$('#viewport').on('swipeleft', function(e, data){
			window.location.href = $next.attr('href');
		});
	
	});

});